import RemoveTagFromDataItemRequestModelBase from '../_generated/modelBases/remove-tag-from-data-item-request-model-base';

export default class RemoveTagFromDataItemRequestModel extends RemoveTagFromDataItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
